let html = `
<svg><use xlink:href="#sprite-top"></use></svg>
`

export default html